"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DpBadges = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_i18next_1 = require("react-i18next");
var Common_1 = require("../../Common");
var DpBadges_styled_1 = require("./DpBadges.styled");
var DpBadges = function (_a) {
    var _b = _a.badges, badges = _b === void 0 ? [] : _b, _c = _a.maxToShow, maxToShow = _c === void 0 ? null : _c, _d = _a.variant, variant = _d === void 0 ? 'badge' : _d, _e = _a.className, className = _e === void 0 ? '' : _e, _f = _a.capitalization, capitalization = _f === void 0 ? 'uppercase' : _f, _g = _a.moreButton, moreButton = _g === void 0 ? null : _g, onClickBadge = _a.onClickBadge;
    var t = (0, react_i18next_1.useTranslation)('assessment').t;
    /**
     * Creates a list of badges to display
     */
    var badgesList = (0, react_1.useMemo)(function () {
        var displayedBadges = maxToShow ? badges.slice(0, maxToShow) : badges;
        if (maxToShow && badges.length > maxToShow && variant === 'badge') {
            displayedBadges.push({
                text: moreButton && moreButton.text ? moreButton.text : t('DpBadges.badgeMore'),
                'aria-label': moreButton && moreButton['aria-label']
                    ? moreButton['aria-label']
                    : t('DpBadges.badgeMore'),
            });
        }
        return displayedBadges.map(function (data) {
            return onClickBadge ? ((0, jsx_runtime_1.jsx)("button", { onClick: function () { return onClickBadge(data === null || data === void 0 ? void 0 : data.info); }, className: "btn-clearfix button-badge", "aria-label": data['aria-label'], children: (0, jsx_runtime_1.jsx)("span", { className: "badge", children: data.text }) }, data.text)) : ((0, jsx_runtime_1.jsxs)("div", { className: "text-badge", children: [(0, jsx_runtime_1.jsx)("span", { className: "visually-hidden", children: data['aria-label'] }), (0, jsx_runtime_1.jsx)("span", { "aria-hidden": true, className: "badge", children: data.text })] }, data.text));
        });
    }, [t, variant, maxToShow, badges, moreButton, onClickBadge]);
    return ((0, jsx_runtime_1.jsxs)(DpBadges_styled_1.StyledBadges, { "data-testid": "affirm-dp-badges", className: className, transformation: capitalization, children: [badgesList, maxToShow && badges.length > maxToShow && variant === 'icon' && (0, jsx_runtime_1.jsx)(Common_1.Icon, { name: "plus" })] }));
};
exports.DpBadges = DpBadges;
exports.default = exports.DpBadges;
